'use client';

import posthog from 'posthog-js';
import { PostHogProvider as Provider } from 'posthog-js/react';
import type { PropsWithChildren } from 'react';

import { useUser } from '@/contexts/useUser';

export const PostHogProvider = (
  props: PropsWithChildren<{ clientKey: string | undefined }>
) => {
  const { user, currentProjectId } = useUser();

  if (!user?.id || !props.clientKey) {
    return props.children;
  }

  if (user.email?.endsWith('support@eon.io')) {
    return props.children;
  }

  if (user.givenName?.toLowerCase().includes('eon support')) {
    return props.children;
  }

  if (typeof window !== 'undefined') {
    posthog.init(props.clientKey, {
      api_host: '/ingest',
      ui_host: 'https://us.posthog.com',
      person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
      mask_all_text: true,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '*',
      },
    });
  }

  posthog.identify(user.id, {
    email: user.email,
    name: user.givenName,
    project: currentProjectId,
    eonAccountId: user.eonAccount.id,
  });

  return <Provider client={posthog}>{props.children}</Provider>;
};
